import { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Button, Container, Form } from "react-bootstrap";
import { AvatarEditor } from "../components/UserAvatar";

const AccountSettingsPage = () => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [busy, setBusy] = useState(false);
    const [me, setMe] = useState(null);

    useEffect(() => {
        axios
            .get("/api/protected/user", { withCredentials: true })
            .then((res) => setMe(res.data?.user || null))
            .catch(() => setMe(null));
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        if (newPassword !== confirmPassword) {
            setError("Новий пароль і підтвердження не збігаються");
            return;
        }
        if (newPassword.length < 8) {
            setError("Новий пароль — мінімум 8 символів");
            return;
        }
        setBusy(true);
        try {
            await axios.post(
                "/api/protected/change-password",
                { currentPassword, newPassword },
                { withCredentials: true }
            );
            setSuccess("Пароль успішно змінено");
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
        } catch (err) {
            setError(err.response?.data?.error || "Не вдалося змінити пароль");
        } finally {
            setBusy(false);
        }
    };

    return (
        <Container className="py-4" style={{ maxWidth: 480 }}>
            <h1 className="h4 mb-3">Обліковий запис</h1>

            {me ? (
                <div className="mb-4">
                    <AvatarEditor user={me} onChange={(updated) => setMe((prev) => ({ ...prev, ...updated }))} />
                </div>
            ) : null}

            <p className="text-muted small mb-4">Зміна пароля для входу в систему.</p>

            <Form onSubmit={handleSubmit}>
                {error ? (
                    <Alert variant="danger" className="py-2">
                        {error}
                    </Alert>
                ) : null}
                {success ? (
                    <Alert variant="success" className="py-2">
                        {success}
                    </Alert>
                ) : null}

                <Form.Group className="mb-3" controlId="currentPassword">
                    <Form.Label>Поточний пароль</Form.Label>
                    <Form.Control
                        type="password"
                        autoComplete="current-password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="newPassword">
                    <Form.Label>Новий пароль</Form.Label>
                    <Form.Control
                        type="password"
                        autoComplete="new-password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        minLength={8}
                    />
                    <Form.Text className="text-muted">Мінімум 8 символів</Form.Text>
                </Form.Group>
                <Form.Group className="mb-3" controlId="confirmPassword">
                    <Form.Label>Підтвердження нового пароля</Form.Label>
                    <Form.Control
                        type="password"
                        autoComplete="new-password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        minLength={8}
                    />
                </Form.Group>
                <Button type="submit" variant="primary" disabled={busy}>
                    {busy ? "Збереження…" : "Змінити пароль"}
                </Button>
            </Form>
        </Container>
    );
};

export default AccountSettingsPage;
